import CreateEndpointBody from '../components/createEndpoint/createEndpointBody';

const CreateEndpoint = () => (
      <>
       <CreateEndpointBody />
      </>
);

export default CreateEndpoint;
